import React, { useState, useEffect } from 'react';

const CustomerForm = ({ customer, onSave, onCancel }) => {
    const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', phone: '', notes: '' });
    const [createLoyalty, setCreateLoyalty] = useState(false);

    useEffect(() => {
        if (customer) {
            setFormData({
                firstName: customer.firstName || '',
                lastName: customer.lastName || '',
                email: customer.email || '',
                phone: customer.phone || '',
                notes: customer.notes || '',
            });
        } else {
            setFormData({ firstName: '', lastName: '', email: '', phone: '', notes: '' });
        }
    }, [customer]);

    const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    
    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData, createLoyalty);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First Name*" required className="p-2 border rounded-md w-full" />
                <input name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name*" required className="p-2 border rounded-md w-full" />
                <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="Email" className="p-2 border rounded-md w-full" />
                <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone" className="p-2 border rounded-md w-full" />
            </div>
            <textarea name="notes" value={formData.notes} onChange={handleChange} placeholder="Customer Notes..." rows="4" className="w-full p-2 border rounded-md"></textarea>
            {!customer && (
                <label className="flex items-center">
                    <input type="checkbox" checked={createLoyalty} onChange={(e) => setCreateLoyalty(e.target.checked)} className="mr-2" /> Create Loyalty Card
                </label>
            )}
            <div className="flex justify-end space-x-3 pt-4">
                <button type="button" onClick={onCancel} className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md">Cancel</button>
                <button type="submit" className="bg-primary text-white px-4 py-2 rounded-md">Save Customer</button>
            </div>
        </form>
    );
};

export default CustomerForm;